import { Component, inject, input } from '@angular/core';
import { TableContext } from '../../../services/table/table-context.service';
import { NgStyle } from '@angular/common';
import { TableHead } from '../table.interface';

@Component({
  selector: 'app-group-cols',
  imports: [NgStyle],
  templateUrl: './group-cols.component.html',
  styleUrl: './group-cols.component.scss',
})
export class GroupColsComponent {
  col = input.required<TableHead>();
  rowIndex = input.required<number>();
  tableContext = inject(TableContext);
}
